import * as QRCodeLib from "qrcode";
import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getEncryptedFormUrl } from "../../../../actions/forms";
import OpenFormQrDialog from "./OpenFormQrDialog";

const OpenFormQRDialogContainer = ({ form, open, onClose }) => {
  const dispatch = useDispatch();
  const baseUrl = window.location.origin;
  const formCommonProperties = useSelector((state) => state.formsState.commonProperties);
  const selectedProvider = useSelector((state) => state.providers.selectedProvider);
  const [qr, setQr] = useState(null);

  const getFormQr = useCallback(() => {
    if (open) {
      dispatch(getEncryptedFormUrl({
        accidentId: formCommonProperties.idSiniestro,
        wriId: formCommonProperties.idArt,
        providerId: selectedProvider
      })).then(({ value }) => {
        QRCodeLib.toDataURL(`${baseUrl}${CONFIG.path}/responsiveform/${value.data}`, { width: 300, margin: 15 }, (error, url) => {
          setQr(url);
        });
      });
    }
  }, [
    formCommonProperties.idSiniestro,
    formCommonProperties.idArt,
    selectedProvider,
    dispatch,
    open,
  ]);

  useEffect(() => {
    getFormQr(form);
  }, [open, form])

  return (
    <OpenFormQrDialog
      form={form}
      qr={qr}
      open={open}
      onClose={onClose}
    />
  )


}


export default OpenFormQRDialogContainer;